module.exports = __webpack_public_path__ + "static/media/jaume-collboni_PSC.1b20cc2f.png";